import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-auto-allocation-solution',
  imports: [RouterModule, FeatureHero],
  templateUrl: './auto-allocation-solution.html',
  styleUrl: './auto-allocation-solution.scss',
})
export class AutoAllocationSolution {

}
